export function generateMockAnalysis(vehicle) {
  const currentYear = new Date().getFullYear();
  const age = currentYear - (vehicle.year || currentYear);
  const mileage = parseInt(vehicle.mileage) || 50000;

  return {
    vehicleSummary: {
      year: vehicle.year,
      make: vehicle.make,
      model: vehicle.model,
      mileage: mileage,
    },
    healthScore: Math.max(60, 90 - Math.floor(age / 5) * 3 - Math.floor(mileage / 50000) * 3),
    healthSummary:
      mileage > 100000
        ? 'High-mileage vehicles that are well-maintained can be extremely reliable. Stay on top of scheduled services — fluids, filters, belts, and brakes — and this vehicle will continue to serve you well.'
        : mileage > 50000
          ? 'Your vehicle is entering mid-life. Most factory warranties have expired. Staying ahead of wear items and fluid changes is the best investment you can make in reliability.'
          : 'Your vehicle is relatively low-mileage. Keep up with scheduled maintenance and it should serve you well for years to come.',
    maintenanceItems: [
      {
        service: 'Oil & Filter Change',
        urgency: mileage % 5000 > 3500 ? 'high' : 'medium',
        description: 'Full synthetic oil and filter replacement',
        costDealer: '$85–$120',
        costShop: '$55–$75',
        costDIY: '$30–$45',
        difficulty: 'Beginner',
        dueMileage: Math.ceil(mileage / 5000) * 5000,
      },
      {
        service: 'Brake Pad Inspection',
        urgency: mileage > 40000 ? 'high' : 'low',
        description: 'Check front and rear brake pad thickness and rotor condition',
        costDealer: '$150–$300',
        costShop: '$100–$200',
        costDIY: '$40–$80',
        difficulty: 'Intermediate',
        dueMileage: Math.ceil(mileage / 30000) * 30000,
      },
      {
        service: 'Tire Rotation',
        urgency: 'medium',
        description: 'Rotate tires to ensure even wear across all four positions',
        costDealer: '$40–$60',
        costShop: '$25–$40',
        costDIY: '$0 (with jack)',
        difficulty: 'Beginner',
        dueMileage: Math.ceil(mileage / 7500) * 7500,
      },
      {
        service: 'Cabin Air Filter',
        urgency: 'low',
        description: 'Replace cabin air filter for improved HVAC performance',
        costDealer: '$60–$80',
        costShop: '$35–$50',
        costDIY: '$12–$20',
        difficulty: 'Beginner',
        dueMileage: Math.ceil(mileage / 15000) * 15000,
      },
      {
        service: 'Transmission Fluid',
        urgency: mileage > 60000 ? 'high' : 'low',
        description: 'Drain and fill transmission fluid to maintain smooth shifting',
        costDealer: '$200–$350',
        costShop: '$150–$250',
        costDIY: '$50–$90',
        difficulty: 'Advanced',
        dueMileage: Math.ceil(mileage / 60000) * 60000,
      },
      {
        service: 'Coolant Flush',
        urgency: mileage > 50000 ? 'medium' : 'low',
        description: 'Replace engine coolant to prevent overheating and corrosion',
        costDealer: '$120–$180',
        costShop: '$80–$130',
        costDIY: '$25–$40',
        difficulty: 'Intermediate',
        dueMileage: Math.ceil(mileage / 50000) * 50000,
      },
    ],
    marketValue: {
      estimate: `$${(Math.max(5000, 35000 - age * 2800 - Math.floor(mileage / 1000) * 80)).toLocaleString()} – $${(Math.max(7000, 40000 - age * 2800 - Math.floor(mileage / 1000) * 80)).toLocaleString()}`,
      trend: age <= 3 ? 'stable' : 'declining',
      trendNote:
        age <= 3
          ? 'Holding value well for its age. Low depreciation window.'
          : 'Normal depreciation curve. Maintain service records to preserve resale value.',
      recentSales: [
        `Autotrader: $${(Math.max(5500, 36000 - age * 2800 - Math.floor(mileage / 1000) * 80)).toLocaleString()} (recent listing, comparable condition)`,
        `eBay Motors: $${(Math.max(4800, 33000 - age * 2800 - Math.floor(mileage / 1000) * 80)).toLocaleString()} (sold listing, similar mileage)`,
      ],
      valueFactors: 'Service history and condition are the primary value drivers for this vehicle.',
      dataSource: 'Based on mock data — connect API for real market valuations',
    },
  };
}
